import { Component, Input, OnInit, OnDestroy } from '@angular/core'
import { TranslateService } from '@ngx-translate/core'
import { Subscription } from 'rxjs'
import { SharedService } from 'src/app/shared/services/shared.service'
import { productTabs } from '../../models/products.enum'
import { ActivatedRoute, Router } from '@angular/router'
import { environment } from 'src/environments/environment'
import { productListModel } from '../../models/products.model'
import { ProductsService } from '../../services/products.service'

@Component({
	selector: 'app-products-list',
	templateUrl: './products-list.component.html',
	styleUrls: ['./products-list.component.scss'],
})
export class ProductsListComponent implements OnInit, OnDestroy {
	subscription = new Subscription()
	activeCountries!: any
	productTabs = productTabs
	productFilter: any = {
		paging: { pageNumber: 1, pageSize: 10 },
		countryId: 224,
		searchText: '',
		status: 0,
		filterCount: 0,
	}
	filterCount = 0
	attachmentURL: string = environment.attachmentPath
	attachmentLink = environment.baseURL
	activeCount: any
	@Input() productsList: productListModel[] = []

	totalCount = 0
	cachedFilter: any
	constructor(
		private sharedService: SharedService,
		public translate: TranslateService,
		private router: Router,
		private productsService: ProductsService
	) {
		this.sharedService.headerTitle.next(`STORE.PRODUCT_LIST.PAGE_TITLE`)
	}

	ngOnInit(): void {
		// Restore filter state from localStorage
		const savedFilterState = localStorage.getItem('productFilter')
		if (savedFilterState) {
			this.productFilter = JSON.parse(savedFilterState)
			this.filterCount = this.productFilter.filterCount
			this.cachedFilter = this.productFilter
		}

		this.getActiveCountries()
		this.sharedService.handleBreadCrumb('Product-List', true, {
			name: '',
			id: '',
			url: '/layout/store/products',
		})
		this.getProductsList()
		this.getActiveCount()
	}
	countryChange(countryId: number) {
		this.productFilter.countryId = countryId
		this.getProductsList()
		this.getActiveCount()
	}
	getProductsList(search = false, filter: any = null) {
		search ? (this.productFilter.paging.pageNumber = 1) : null
		filter ? (this.productFilter = { ...this.productFilter, ...filter }) : null
		this.subscription.add(
			this.productsService
				.getProductsList(this.productFilter)
				.subscribe((res: any) => {
					this.productsList = res.result.items
					this.totalCount = res?.result.totalCount
					this.saveFilterState() // Save state after fetching products
				})
		)
	}

	getActiveCount(search = false, filter: any = null) {
		search ? (this.productFilter.paging.pageNumber = 1) : null
		filter ? (this.productFilter = { ...this.productFilter, ...filter }) : null

		this.subscription.add(
			this.productsService
				.SearchAllTabCount(this.productFilter)
				.subscribe((res: any) => {
					this.activeCount = res?.result.activeCount
					let active = this.productTabs.find((val) => val.value == '0')
					if (active) {
						active.count = this.activeCount
						active.showCount = !!res?.result.activeCount
					}
				})
		)
	}

	tapChanged(event: any) {
		this.productFilter.paging.pageNumber = 1
		this.productFilter.status = event
		this.getProductsList()
		this.getActiveCount()
	}

	searchTextChanged(event: any) {
		this.productFilter.searchText = event
		if (this.cachedFilter) {
			this.cachedFilter.searchText = event
		}
		this.saveFilterState()
		this.getProductsList()
		this.getActiveCount()
	}

	pagingChanged(pageNumber: number, pagecount: number) {
		this.productFilter.paging.pageNumber = pageNumber
		this.productFilter.paging.pageSize = pagecount
		this.getProductsList()
		this.getActiveCount()
	}

	getActiveCountries() {
		this.subscription.add(
			this.sharedService.getActiveCountries().subscribe((res: any) => {
				this.activeCountries = res
			})
		)
	}

	FabNavigation() {
		this.saveFilterState()
		this.router.navigate(['/layout/store/products/add-product'])
	}

	saveFilterState() {
		this.productFilter.filterCount = this.filterCount
		localStorage.removeItem('productFilter')
		localStorage.setItem('productFilter', JSON.stringify(this.productFilter))
	}
	exportProductsToExcel() {
		let body = this.productFilter
		delete body.filterCount
		this.subscription.add(
			this.productsService.exportProductsToExcel(body).subscribe((res: any) => {
				let downloadLink = this.attachmentLink + res.result
				console.log(downloadLink)

				const link = document.createElement('a')
				link.setAttribute('target', '_blank')
				link.setAttribute('href', downloadLink)
				link.setAttribute('download', `products.csv`)
				document.body.appendChild(link)
				link.click()
				link.remove()
			})
		)
	}

	ngOnDestroy(): void {
		this.saveFilterState()
		this.saveFilterState()
		this.subscription.unsubscribe()
	}
}
